import React, { forwardRef } from 'react';
import { func, shape } from 'prop-types';
import { noop } from 'lodash';
import { I18n, translate } from '@fiverr-private/i18n-react';
import { EducationTooltip } from '@fiverr-private/orca';
import { Tag } from '@fiverr-private/fit';
import { BRIEF_DATA } from '../../Listings/constants';
import FilterButton from '../shared/FilterButton';
import { TOOLTIP_STORAGE_KEY } from '../shared/constants';
import useStaticFilters from './hooks/useStaticFilters';
import { STATIC_FILTERS, FILTERS_MAP } from './constants';

import classes from './index.module.scss';

const StaticFilters = ({ briefData = {}, setBriefData = noop }, ref) => {
    const {
        activeFilter,
        chips,
        selectedFilters,
        handleActiveFilterClick,
        handleRemoveChip,
    } = useStaticFilters({ briefData, setBriefData });

    const Filter = FILTERS_MAP[activeFilter];

    return (
        <div ref={ref} className={classes.staticFiltersWrapper}>
            <div className={classes.titleBlock}>
                <h5>
                    <I18n k="variations_display.marketplace_listing.static_filters.title" />
                </h5>
            </div>
            <div className={classes.filterButtonsWrapper}>
                <div className={classes.filterButtonsGroup}>
                    {STATIC_FILTERS.map((type) => (
                        <FilterButton
                            key={type}
                            onClick={handleActiveFilterClick(type)}
                            className={classes.filterButton}
                            active={activeFilter === type}
                            selected={selectedFilters[type]}
                        >
                            <I18n
                                k={`variations_display.marketplace_listing.static_filters.${type}`}
                            />
                        </FilterButton>
                    ))}
                    <EducationTooltip
                        className={classes.filterTooltip}
                        title={translate(
                            'variations_display.marketplace_listing.tooltip.title'
                        )}
                        body={translate(
                            'variations_display.marketplace_listing.tooltip.body'
                        )}
                        badgeTitle={translate(
                            'variations_display.marketplace_listing.tooltip.badge'
                        )}
                        closeTitle={translate(
                            'variations_display.marketplace_listing.tooltip.cta'
                        )}
                        maxWidth={276}
                        appendToBody={false}
                        bindBodyClickListener={false}
                        tooltipStorageKey={TOOLTIP_STORAGE_KEY}
                        position={EducationTooltip.POSITIONS.BOTTOM}
                    />
                </div>
            </div>

            {!!chips.length && (
                <div className={classes.filterChipsWrapper}>
                    {chips.map(({ filter, value, title }) => (
                        <Tag
                            className={classes.filterChip}
                            key={value}
                            size={Tag.SIZES.SMALL}
                            color={Tag.COLORS.LIGHT_GREY}
                            handleDismiss={handleRemoveChip(filter, value)}
                        >
                            {
                                // eslint-disable-next-line no-undef
                                title(i18n)
                            }
                        </Tag>
                    ))}
                </div>
            )}

            <div className={classes.activeFilterWrapper}>
                <Filter briefData={briefData} setBriefData={setBriefData} />
            </div>
        </div>
    );
};

StaticFilters.propTypes = {
    briefData: shape(BRIEF_DATA),
    setBriefData: func,
};

export default forwardRef(StaticFilters);
